import varAxios from "../../Comman/axios";
import {
    addFaqUrl, deleteFaqUrl,
    updateFaqUrl, getFaqListUrl, updateFAQSequenceUrl
} from '../../Comman/apiEndPoints';

export const Fetch_All_FAQ_LIST_Data = "Fetch_All_FAQ_LIST_Data";
export const FAQ_Success = "FAQ_Success";
export const Fetch_FAQ_Request = "Fetch_FAQ_Request";

export function getAllFAQList() {
    return (dispatch) => {
        dispatch(fetchFAQRequest(true))
        return varAxios.get(getFaqListUrl)
            .then(response => {
                dispatch(
                    fetchAllFAQListData(false, response.data.errorCode, response.data.statusCode, response.data.Message,
                        response.data.questionAnswerList))
            })
            .catch((error) => {
                console.log("error", error);
            })
    }
}
export function fetchAllFAQListData(isLoading, errorCode, statusCode, message, list) {
    return {
        type: Fetch_All_FAQ_LIST_Data,
        isLoading,
        errorCode,
        statusCode,
        message,
        list
    }
}
export function addFaq(payload) {
    return (dispatch) => {
        dispatch(fetchFAQRequest(true))
        return varAxios.post(addFaqUrl, payload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    faqSuccess(false, response.data.errorCode, response.data.statusCode, response.data.Message)
                );
            })
            .catch((error) => {
                console.log(error)
            })
    }
}
export function faqSuccess(isLoading, errorCode, statusCode, message) {
    return {
        type: FAQ_Success,
        isLoading,
        errorCode,
        statusCode,
        message
    }
}

export function deleteFAQData(payload) {
    return (dispatch) => {
        dispatch(fetchFAQRequest(true))
        return varAxios.post(deleteFaqUrl, payload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    faqSuccess(false, response.data.errorCode, response.data.statusCode, response.data.Message)
                );
            })
            .catch((error) => {
                console.log(error)
            })
    }
}
// export function CarouselDataSuccess(errorCode, statusCode, Message, list) {
//     return {
//         type: Carousel_Data_Success,
//         errorCode,
//         statusCode,
//         Message,
//         list
//     }
// }
export function updateFaq(payload) {
    return (dispatch) => {
        dispatch(fetchFAQRequest(true))
        return varAxios.post(updateFaqUrl, payload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    faqSuccess(false, response.data.errorCode, response.data.statusCode, response.data.Message)
                );
            })
            .catch((error) => {
                console.log(error)
            })
    }
}
export function fetchFAQRequest(isLoading) {
    return {
        type: Fetch_FAQ_Request,
        isLoading
    }
}
export function updateFAQSequence(data) {
    return (dispatch) => {
        dispatch(fetchFAQRequest(true))
        return varAxios.post(updateFAQSequenceUrl, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    faqSuccess(false, response.data.errorCode, response.data.statusCode, response.data.Message)
                );
            })
            .catch((error) => {
                console.log(error)
            })
    }
}